@if (displayWarningMessage) {
  <pxw-tag size="xs" type="warning">
    <pxw-icon icon="alert" />
    {{ message }}
  </pxw-tag>
}
